import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import Grid from '@mui/material/Grid';
import { get } from '@truefit/http-utils';

type Props = {
  onRender: () => void;
};

const Component = ({ onRender }: Props) => {
  React.useEffect(() => {
    // This will load a CSRF token in a cookie that will be automatically discovered
    // by the axios library in order to use double submit cookie CSRF protection.
    // This is important to use if you are using cookies to store any kind of
    // sensitive data like a JWT or other token or you're using cookie based auth.
    // You can find more details of the attack here: https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html
    // And the mitigation method we are using here: https://cheatsheetseries.owasp.org/cheatsheets/Cross-Site_Request_Forgery_Prevention_Cheat_Sheet.html#double-submit-cookie
    // This requires configuration on the API side to validate the XSRF token
    // correctly.
    const getToken = async () => {
      try {
        await get('/v1.0/antiforgery-token');
      } catch (e) {
         
        console.error('Failed to request an antiforgery token.');
         
      } finally {
        onRender();
      }
    };

     
    getToken();
  }, [onRender]);

  return (
    <Fade
      in
      style={{
        transitionDelay: '800ms',
      }}
      unmountOnExit
    >
      <Grid
        container
        direction="column"
        sx={{ height: '100vh', justifyContent: 'center', alignContent: 'center' }}
      >
        <Grid>
          <CircularProgress size={200} />
        </Grid>
      </Grid>
    </Fade>
  );
};

export default Component;
